
import { supabase } from '../../supabase';
import { UTMStat } from '../types';
import { AuthFilter } from '@/components/analytics/AuthFilterButtons';

/**
 * Get UTM campaign performance
 */
export const getUTMStats = async (
  startDate: Date,
  endDate: Date,
  authFilter: AuthFilter = 'all'
): Promise<UTMStat[]> => {
  const { data, error } = await supabase.rpc('get_utm_performance', {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
    auth_filter: authFilter
  });

  if (error) {
    console.error('Error fetching UTM stats:', error);
    throw error;
  }

  return (data || []).map(item => ({
    utm_source: item.utm_source,
    utm_medium: item.utm_medium,
    utm_campaign: item.utm_campaign,
    visits: Number(item.visits),
    unique_sessions: Number(item.unique_sessions)
  }));
};
